import React from 'react';
import { useStowageStore } from 'src/context/StowageContext';
import OperationListContextMenu from './OperationListContextMenu';
import { OperationMenuWrapper } from '../OperationListView.styles';
import { useStowageSelectionStore } from 'src/context/StowageSelectionContext';

const OperationListContextMenuWrapperComponent: React.FC = () => {
    const { operationListContextMenuState } = useStowageStore();
    const { selectedCargoOperation } = useStowageSelectionStore();

    return (
        <OperationMenuWrapper>
            {operationListContextMenuState.visible && selectedCargoOperation && (
                <OperationListContextMenu contextMenuState={operationListContextMenuState} selectedCargoOperation={selectedCargoOperation} />
            )}
        </OperationMenuWrapper>
    );
};

export default OperationListContextMenuWrapperComponent;
